// Imports

import { useHistory, useLocation } from "react-router-dom"
import { UpgradeCompletionDialog, useToken } from "trux"
import React, { useEffect, useState } from "react"
import { parseQuery } from "../../util/query"
import { useSelector } from "react-redux"

import { useFindProfileLazyQuery, useFindProfileQuery } from "../../generated/graphql"
import { webApi } from "../../lib/WebApi"

// Upgrade Completion Dialog

const UpgradeCompletionDialogComponent = ({ 
    match, 
    buttonTitle, 
    showButton, 
    upgradedTo, 
    hideCloseButton, 
    showConfirmationText, 
    onClose, 
    onAction 
}) => {

    // Location & history

    const history = useHistory()
    const location = useLocation()
    const searchParams = parseQuery(location.search)
    const userId = searchParams ? parseInt(searchParams["user_id"], 10) : null
    const [postedToSlack, setPostedToSlack] = useState(false)
    const [confirmedUpgrade, setConfirmedUpgrade] = useState(false)
    const [upgradeFailed, setUpgradeFailed] = useState(false)

    const success = location && location.pathname ? location.pathname.includes("success") : false

    let user = useSelector(state => state.user.value)

    // Get the profile

    const token = useToken("SaveToPlaylist")
    const tokenReady = token !== null

    const {
        data: profileData,
        loading: profileLoading,
        error: profileError,
    } = useFindProfileQuery({
        variables: {
            user_id: parseInt(userId),
            token: token,
        },
        skip: (!tokenReady || !userId),
    })

    const [ findProfile ] = useFindProfileLazyQuery({
        variables: {
            user_id: parseInt(userId),
            token: token,
        },
        skip: (!tokenReady || !userId),
        fetchPolicy: "network-only"
    })

    const afterSubscriptionCheckTimeout = () => {
        if (!confirmedUpgrade) {
            setUpgradeFailed(true)
        }
    }

    // Fetch the user until we know that they have a subscription
    useEffect(() => {

        const fetchUserProfile = async () => {
            const userProfileRes = await findProfile({
                
            })
            const newFetchedUserProfile = userProfileRes?.data?.profile
            if (newFetchedUserProfile?.permission?.plan_type === "pro") setConfirmedUpgrade(true)
        }

        const interval = setInterval(() => {
            // Fetch the user every 2 seconds to get the 
            // updated subscription status. Do this only
            // if the user is not subscribed.
            if (!confirmedUpgrade) {
                fetchUserProfile()
            } else {
                clearInterval(interval)
            }
        }, 2000)

        // Clear the timeout after 15 seconds.
        setTimeout(function() {
            afterSubscriptionCheckTimeout()
            clearInterval(interval)
        }, 11000)
        
        return () => clearInterval(interval)

    }, [confirmedUpgrade])

    useEffect(() => {
        if (success && !postedToSlack && ["family","team"].includes(upgradedTo)) {
            const usersName = user ? `${user.first_name} ${user.last_name}` : "UNKNOWN_USER_NAME"
            const usersEmail = user ? user.email : "UNKNOWN_EMAIL"
            const usersId = user ? user.user_id : "UNKNOWN_ID"
            webApi.postSlack(
                `:warning: ATTENTION: \n\n ${usersName} (ID: ${usersId}) requested to upgrade to a trace ${upgradedTo} subscription. \n They can be reached via email at ${usersEmail}. \n cc <@UJW5PNR96> <@U049L9L3D> <@U495U19BP> <@U02PZNMK9K8>`,
                null,
                null,
                "C4A826EJE"
            ).then(() => {
                setPostedToSlack(true)
            }).catch(() => {
                setPostedToSlack(false)
            })
        }
    }, [success, postedToSlack, upgradedTo, user])

    const profile = profileData ? profileData.profile : null

    const handleCloseButtonClick = () => {
        if (typeof onClose === "function") {
            onClose(history, location)
        } else {
            let redirectURL = location.pathname
            redirectURL = redirectURL.replace(/goS\/upgrade.*\/.*$/, "")
            history.replace(redirectURL)
        }
    }

    const handleActionButtonClick = (upgradedTo, profile) => {
        if (typeof onAction === "function") {
            onAction(userId)
        }
    }

    return (
        <UpgradeCompletionDialog
            success={success}
            profile={profile}
            buttonTitle={buttonTitle}
            hideCloseButton={hideCloseButton}
            showButton={showButton}
            upgradedTo={upgradedTo}
            showConfirmationText={showConfirmationText}
            onClose={handleCloseButtonClick}
            onAction={(upgradedTo, profile) => handleActionButtonClick(upgradedTo, profile)}
            confirmedUpgrade={confirmedUpgrade}
            upgradeFailed={upgradeFailed}
        />
    )
}

UpgradeCompletionDialogComponent.defaultProps = {
    buttonTitle: "Upgrade additional family members",
    showButton: false,
    upgradedTo: "traceId",
    showConfirmationText: false,
    hideCloseButton: false,
}

export { UpgradeCompletionDialogComponent }
